var exports = {
  "P": "iconWrapper__JDRDnU",
};

module.exports = exports;
